import Layout from "../Frames/Layout"
import { useState } from "react";
import { Stack, Button, Fab } from "@mui/material";
import Toast from "../Tools/Toast";
import '../../css/social.css';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate, useParams } from "react-router-dom";
import Search from "./Search";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import { Tags } from "./Tags";
import Posts from "./Posts";
import { txt } from "../../services/translation";

export default function Index(){

    const {user} = useContext(UserContext)

    const navigate = useNavigate();
    const {filter, id} = useParams();

    const [search, setSearch] = useState('')
    const [tag, setTag] = useState( user.tags?.find(t => t.type?.id === 'category') || null )
    const [toast, setToast] = useState(false)
    

    const handleSearch = e => {
        e.preventDefault();
        return setSearch(e.target.search.value);
    }


    return <Layout tab={filter === 'posts' ? 'feed' : filter} menu='social' className='social'>

        <div className='social-main'>

            {!id && <div className='social-box'>

                <Stack direction='row' spacing={2} sx={{mt:1, mb: 1}}>

                    <Search onSubmit={handleSearch} onTagClick={tag => setTag(tag)} />
                    
                    <div className='social-new-button'>
                        <Button
                            variant='contained'
                            startIcon={<EditIcon />}
                            onClick={() => navigate('/community/posts/new/edit')}
                            sx={{height: 40}}
                        >
                            {txt('newPost')}
                        </Button>
                    </div>

                </Stack>

                <Tags tag={tag} onChange={tag => setTag(tag)} />

            </div>}


            <Posts 
                search={search}
                tag={tag} 
                filter={filter} 
                id={id}
                courseId={null}
                onTagClick={tag => setTag(tag)}
            />

        </div>


        <div className='social-new-float'>
            <Fab color="primary" size='medium' onClick={() => navigate('/community/posts/new/edit')}>
                <EditIcon />
            </Fab>
        </div>
        

        <Toast
            open={toast ? true : false} 
            severity={toast?.severity} 
            duration={5000} 
            onClose={() => setToast(false)}
            message={toast?.message}
        />

    </Layout>
}


